import * as React from 'react';
import H5CommonComponent from '@tencent/h5-common-component';
import { throttle } from 'lodash';
import { useEffect, useImperativeHandle, useRef, useState } from 'react';
const DEFAULT_BASE64 = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
const EVENT_LIST = ['cropend', 'zoom'];
const ImageCropper = (props, ref) => {
    const { imgBase64, resultImgSize, maskImgUrl, onImageEvent, autoCropArea, ratio, viewMode, initialScale, isNeedFixedCrop, fixedCropInfo, isNeedBackground, autoCropLocation, minContainerWidth, } = props;
    const cropLayer = useRef(null);
    const [imageCropperInstance, setImageCropperInstance] = useState(null);
    const updateImage = () => {
        const $cropMask = cropLayer.current.querySelector('.mask-image');
        cropLayer.current.innerHTML = '';
        $cropMask && cropLayer.current.append($cropMask);
        const imageCropper = new H5CommonComponent.ImageCropper({
            imgBase64: imgBase64 || DEFAULT_BASE64,
            containerElement: cropLayer.current,
            resultImgSize: 1024,
            initialScale: initialScale || 1.1,
            autoCropArea: autoCropArea || 1,
            maskImgUrl,
            ratio: ratio || 307 / 338,
            viewModeInfo: viewMode,
            compressRatio: 0.95,
            isNeedCropBox: isNeedFixedCrop,
            fixedCropInfo: fixedCropInfo,
            isDefaultBackground: isNeedBackground,
            autoCenterFace: false,
            autoCropLocation: autoCropLocation,
            minContainerWidth: minContainerWidth,
        });
        setImageCropperInstance(imageCropper);
    };
    const handleImageCropEvent = throttle((evt) => {
        if ((!evt.currentTarget && evt.type === 'zoom') || evt.type === 'cropend') {
            onImageEvent && onImageEvent(evt);
        }
    }, 500);
    useEffect(() => {
        updateImage();
    }, [imgBase64, resultImgSize]);
    useEffect(() => {
        EVENT_LIST.forEach(eventName => {
            cropLayer.current.addEventListener(eventName, handleImageCropEvent);
        });
    }, []);
    // 暴露给父组件的方法
    useImperativeHandle(ref, () => ({
        getImageData() {
            return imageCropperInstance && imageCropperInstance.getImageData();
        },
    }));
    return React.createElement("div", { ref: cropLayer, style: { height: '100%' } });
};
export default React.forwardRef(ImageCropper);
